import React, { useEffect } from "react";
import Quiz from "./components/quiz";
import * as Sentry from "@sentry/react";
import ErrorBoundary from "./components/quiz/errorBoundary";
import { email, quizId, quizType, userId, userName } from "./utils/constants";

function App() {
  useEffect(() => {
    Sentry.setContext("attributes", {
      userId: userId,
      userName: userName,
      email: email,
      quizId: quizId,
      quizType: quizType,
    });
  }, []);

  return (
    <div className="App container-Quiz">
      <ErrorBoundary>
        <Quiz quizId={quizId} quizType={quizType} />
      </ErrorBoundary>
    </div>
  );
}

export default App;
